import { useEffect } from "react";

export function SalexorTracking() {
  // Initialize Salexor and send data when user is available
  useEffect(() => {
    let scriptElement: HTMLScriptElement | null = null;

    if (!window?.Salexor) {
      window.myo_pigv = { dealership_id: "c1b54ee5405be8e202a4" };

      scriptElement = safeCreateScript(
        "https://portal.salexor.com/cs/behaviour.spa.js",
        () => {},
        () => console.error("Salexor failed to load"),
      );
    } else {
      const chat = document.getElementById("_slx_chat_app");
      chat.style.display = "block";
    }
    // Cleanup function
    return () => {
      if (scriptElement) {
        console.log("Removing Salexor script");
        safeRemoveChild(scriptElement);
      }
    };
  }, []);

  /**
   * Safely creates and appends a script element
   * @param src - Script source URL
   * @param onLoad - Optional onload callback
   * @param onError - Optional onerror callback
   * @returns The script element for cleanup
   */
  const safeCreateScript = (src: string, onLoad?: () => void, onError?: () => void): HTMLScriptElement => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    if (onLoad) script.onload = onLoad;
    if (onError) script.onerror = onError;

    document.body.appendChild(script);
    return script;
  };

  /**
   * Safely removes a DOM element from its parent
   * @param element - The element to remove
   * @returns boolean indicating if removal was successful
   */
  const safeRemoveChild = (element: HTMLElement | null): boolean => {
    if (!element || !element.parentNode) {
      return false;
    }

    try {
      // Check if the element is still in the DOM
      if (document.body.contains(element)) {
        const chat = document.getElementById("_slx_chat_app");
        if (chat) {
          chat.style.display = "none";
        }
        return true;
      }
    } catch (error) {
      console.warn("Failed to remove DOM element:", error);
    }
    return false;
  };
  return <> </>;
}
